const validate = {
  required: (value) => {
    const isString = (typeof value === 'string');

    if (isString) {
      return !!value && value.trim() !== '';
    } else {
      return !!value;
    }
  },
  minLength: (value, minLength) => {
    return value != null && value.trim().length >= minLength;
  },
  maxLength: (value, maxLength) => {
    return value != null && value.trim().length <= maxLength;
  },
  validEmail: (value) => {
    return !!value.match(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/); // eslint-disable-line
  },
  validTime: (value) => {
    return !!value.match(/^([1-9]|0[1-9]|1[0-2]):[0-5][0-9]$/); // eslint-disable-line
  },
  validInteger: (value) => {
    let intTest = new Int32Array(1);
    intTest[0] = parseInt(value.replace(",",""));
    return (value === "0" || intTest !== 0) ? true : false; // eslint-disable-line
  },
  validDecimal: (value) => {
      return !!value.match(/^-?\d{1,3}(?:\.\d{1,3})?$/); // eslint-disable-line
  },
  length: (value, length) => {
    return !!value && value.trim().length === length;
  },
  numItems: (array, items) => {
    return array.length === items;
  },
  maxItems: (value, maxItems) => {
    return value.length <= maxItems;
  },
  minItems: (value, minItems) => {
    return value.length >= minItems;
  },
  notIn: (value, array) => {
    if (typeof value === 'string') {
      return !array.some(item => item.toLowerCase() === value.toLowerCase())
    } else {
      return !array.includes(value);
    }
  }
}

export default validate;